import {
  Paragraph1 as P1,
  Paragraph2 as P2,
  Paragraph3 as P3
} from '@redoute/paragraphs'
import styled from '@emotion/styled'

const Paragraph1 = styled(P1)`
  font-size: 13px;
  line-height: 120%;
  font-weight: 500;
`

const Paragraph1Regular = styled(Paragraph1)`
  font-weight: 400;
`

const ParagraphSmallCaps = styled(P2)`
  font-size: 11px;
  line-height: 120%;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`

const ParagraphLegend = styled(P3)`
  font-size: 11px;
  line-height: 13px;
  font-weight: 500;
`

export {
  Paragraph1,
  Paragraph1Regular,
  ParagraphSmallCaps,
  ParagraphLegend
}
